import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from 'react-router-dom';
import { useSearch } from './Search';
import { Link } from "react-router-dom";
import logo from "../img/carbon.png";

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const { query, setQuery, results } = useSearch();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const isActive = (path) => location.pathname === path ? "active" : "";

  return (
    <nav className={`navbar navbar-expand-lg ${scrolled ? "nav-scrolled" : ""}`}>
      <div className="container-fluid mx-5">

        <Link className="navbar-brand" to="/">
          <img src={logo} alt="Logo" className="logo" />
        </Link>

        <button
          className="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarSupportedContent"
          aria-controls="navbarSupportedContent"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span className="tog-line"></span>
          <span className="tog-line"></span>
          <span className="tog-line"></span>
        </button>

        <div className="collapse navbar-collapse justify-content-center" id="navbarSupportedContent">
          <ul className="navbar-nav text-center mb-4 mb-lg-0 mx-2">
            <li className="nav-item">
              <a className={`nav-link ${isActive("/")}`} href="/">Naslovna</a>
            </li>
            <li className="nav-item">
              <a className={`nav-link ${isActive("/onama")}`} href="/onama">O nama</a>
            </li>
            <li className="nav-item dropdown">
              <a className="nav-link dropdown-toggle" href="#" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                Usluge
              </a>
              <ul className="dropdown-menu">
                <li><a className="dropdown-item" href="/usluge/pojasevi">Ugradnja pojaseva</a></li>
                <li><a className="dropdown-item" href="/usluge/custom-dizajn-volana">Custom dizajn volana</a></li>
                <li><hr className="dropdown-divider" /></li>
                <li><a className="dropdown-item" href="/galerija">Naši radovi</a></li>
              </ul>
            </li>
            <li className="nav-item">
              <a className={`nav-link ${isActive("/kontakt")}`} href="/kontakt">Kontakt</a>
            </li>
            <li className="nav-item">
              <a className={`nav-link ${isActive("/galerija")}`} href="/galerija">Galerija</a>
            </li>
          </ul>

          <div className="d-flex flex-column flex-lg-row align-items-center ms-lg-auto mt-3 mt-lg-0">
            <button
              className="btn-youtube mb-4 mb-lg-0 mx-4"
              onClick={() => window.open("https://www.youtube.com/@carboncro", "_blank")}
            >
              Carbon.Cro YouTube
            </button>

             <button
              className="btn-instagram-nav mb-4 mb-lg-0 mx-4"
              onClick={() => window.open("https://www.instagram.com/carbon.cro/?hl=hr", "_blank")}
            >
              Carbon.Cro Instagram
            </button>

            <div className="search-wrapper d-flex mb-3 mb-lg-0">
              <input
                className="search-input-s1"
                type="search"
                placeholder="Pretraži..."
                value={query}
                onChange={e => setQuery(e.target.value)}
                onKeyDown={e => {
                  if (e.key === 'Enter' && results.length > 0) {
                    navigate(results[0].url);
                    setQuery('');
                  }
                  if (e.key === 'Escape') setQuery('');
                }}
              />
              <i className="ti ti-search search-icon-s1" aria-hidden="true"></i>

              {results.length > 0 && (
                <div className="search-results-s1">
                  {results.map(item => (
                    <Link
                      key={item.url}
                      to={item.url}
                      className="search-result-item"
                      onClick={() => setQuery('')}
                    >
                      <i className={`ti ti-${item.icon}`} aria-hidden="true"></i>
                      {item.title}
                    </Link>
                  ))}
                </div>
              )}

              {query.length >= 2 && results.length === 0 && (
                <div className="search-results-s1">
                  <p className="search-no-results">Nema rezultata za "{query}"</p>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </nav>
  );
}